import { Link } from "react-router-dom";

import { ROUTES } from "../../../common/navigation";
import useAuth from "../../../hooks/useAuth";
import useBrowseMode from "../../../hooks/useBrowseMode";
import styles from "./BrowsingBanner.module.css";

/**
 * The strip a visitor sees while looking around without an account.
 *
 * It has one job: make the state legible. Browsing shows real football
 * with several things quietly switched off, and without a banner that
 * reads as a broken app rather than a deliberate limit. So it names what
 * is missing before the person discovers it by tapping something that
 * does nothing.
 *
 * Deliberately not a modal. The point of browsing is to look, and a
 * dialog over the thing you came to look at is the opposite of that.
 */
const BrowsingBanner = () => {
  const { status } = useAuth();
  const { browsing } = useBrowseMode();

  if (status === "signed-in" || !browsing) return null;

  return (
    <div className={styles.BrowsingBanner} role="status">
      {/* Short on purpose. This sits above the thing someone came to look
          at, so it names the limit and gets out of the way. The detail it
          used to list is discoverable by tapping a star anyway. */}
      <p className={styles.text}>
        <strong>You&rsquo;re just looking around.</strong> Following a club,
        watching with friends and saving your progress need an account. One
        tap, no email.
      </p>
      <Link to={ROUTES.WELCOME} className={`btn btn-sm btn-primary ${styles.action}`}>
        Get in the game
      </Link>
    </div>
  );
};

export default BrowsingBanner;
